import { ChecklistItemCompletionProps, ChecklistItemProps, ProjectProps } from "@/interfaces/project_types";

/** Print-optimized version of ProjectCard for the Project Report Page */
export function PrintProjectCard({ project, index }: { project: ProjectProps; index: number; }) {
    return (
        <div key={index} className="grid grid-cols-4 px-1 py-2 text-xs border-b">
            <div>
                <h5 className="text-black">
                    {project && project.project_id}
                </h5>
            </div>
            <div>
                {project && project.project_name}
            </div>
            <div className="whitespace-pre-wrap">
                {project.description || ""}
            </div>
            <div>
                <PrintChecklistItemContainer item={project.checklist_items} />
            </div>
        </div>
    );
}

/**
 * Print-optimized checklist container
 */
export function PrintChecklistItemContainer({ item }: { item: ChecklistItemCompletionProps }) {
    return (
        <div className="flex flex-col gap-0 text-xs w-full">
            <PrintChecklistItem item={item.SUBMITTAL_CHECKLIST} label="SUBMITTAL" />
            <PrintChecklistItem item={item.DIG_TESS} label="DIGT ESS" />
            <PrintChecklistItem item={item.ISO} label="ISO" />
            <PrintChecklistItem item={item.THRID_PARTY_REVIEW} label="3RD PARTY REVIEW" />
            <PrintChecklistItem item={item.FLOW_TEST} label="FLOW TEST" />
            <PrintChecklistItem item={item.AG_HYDRO} label="AG HYDRO" />
            <PrintChecklistItem item={item.UG_HYDRO} label="UG HYDRO" />
            <PrintChecklistItem item={item.FDC_CAPS} label="FDC CAPS" />
            <PrintChecklistItem item={item.FINAL} label="FINAL" />
            <PrintChecklistItem item={item.CLOSEOUTS} label="CLOSEOUTS" />
        </div>
    )
}

/** Print-optimized checklist item */
function PrintChecklistItem({ item, label }: { item: ChecklistItemProps, label: string }) {
    const formatted_date = item.completed_date ? 
        new Date(item.completed_date + 'T00:00:00').toLocaleDateString() : ""

    return (
        <div className="grid grid-cols-3 gap-1">
            <h5 className="text-xs font-medium">{label}</h5>
            <div className="text-xs text-right">
                {item.completed ? "✓" : "○"}
            </div>
            {item.completed && formatted_date && (
                <div className="text-xs text-right">
                    {formatted_date}
                </div>
            )}
        </div>
    )
}